import { createBoundedUseStore } from 'common-functions';
import { FunnelQueryCookieObject } from '../cookie-utils/index';
import { createStore } from 'zustand/vanilla';

export type SearchQuery = {
  setQueryObject: (query: FunnelQueryCookieObject | undefined) => void;
  query?: FunnelQueryCookieObject;
};

export const searchQueryStore = createStore<SearchQuery>(set => ({
  setQueryObject: (query: FunnelQueryCookieObject | undefined) =>
    /* disabledLinting - please review disabled rule below */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    set(_state => ({ query }))
}));

export const useSearchQueryStore = createBoundedUseStore(searchQueryStore);
